import type { AndroidBrand, DeviceOS } from '../data/mobileForwarding'

/**
 * Prototype-only phone override set from the Demo Console, so the activation
 * flow can be previewed as an iPhone, a Samsung or another Android phone.
 * `null` means "use the real device".
 */
export type DemoDevice = { os: DeviceOS; androidBrand: AndroidBrand } | null

let current: DemoDevice = null
const listeners = new Set<() => void>()

export const getDemoDevice = () => current

export function setDemoDevice(device: DemoDevice) {
  current = device
  listeners.forEach((l) => l())
}

export function subscribeDemoDevice(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
